import { selfCheckInRoute } from 'src/apis';

export const completeSelfCheckIn = `${selfCheckInRoute}/complete`;
